import { Injectable } from '@angular/core';
import { RequestService, StorageService } from '@nagel-services';
import { environment } from 'apps/nagel-cal-disposition/environment/environment';
import { omsIdsEndpoint } from '../configuration/consts/endpoints';
import { OmsIdsRequest, OmsIdsResponse } from '../../models/planningPageTypes';
import { protectSubscription } from '@nagel-utils';

@Injectable({
    providedIn: 'root'
})
export class OmsLinkService {
    constructor(
        private storageService: StorageService,
        private requestService: RequestService
    ) {
        this.omsIdMap = this.getMap();
    }

    private omsIdMapLocalStorageKey = 'omsIdMap';
    private omsBaseUrl = 'https://elogistics.nagel-group.local/OrderManagementSystem/Consignments/';
    private omsIdMap: Record<number, string> = {};

    loadOmsIds = (shipmentIds: number[]) => {
        const persistedShipmentIds = Object.keys(this.omsIdMap);
        const missingShipmentIds = shipmentIds.filter(id => !persistedShipmentIds.includes(id?.toString() || ''));

        if (missingShipmentIds.length) {
            this.retrieveMissingIds(missingShipmentIds);
        }
    };

    getIsOmsLinkAvailable = (shipmentId: number): boolean => {
        return !!this.omsIdMap[shipmentId];
    };

    editShipmentClick = (isDisabled: boolean, shipmentId?: number) => {
        if (shipmentId && !isDisabled && this.getIsOmsLinkAvailable(shipmentId)) {
            const omsLink = this.getOmsLink(shipmentId);
            if (omsLink) {
                window.open(omsLink, '_blank');
            }
        }
    };

    getOmsLink = (shipmentId: number): string | null => {
        return this.getIsOmsLinkAvailable(shipmentId)
            ? `${this.omsBaseUrl}${this.omsIdMap[shipmentId]}`
            : null;
    };

    private saveMap = () => {
        this.storageService.saveItem(this.omsIdMapLocalStorageKey, JSON.stringify(this.omsIdMap));
    };

    private getMap = () => {
        const storedJson = this.storageService.getItem(this.omsIdMapLocalStorageKey);

        return storedJson ? JSON.parse(storedJson) : {};
    };

    private retrieveMissingIds = (missingShipmentIds: number[]) => {
        if (!missingShipmentIds.length) {
            return;
        }

        const requestPayload =  {
            shipmentIds: missingShipmentIds
        };
        const url = environment.apiUrl + omsIdsEndpoint;
        const requestObservable = this.requestService.postRetrieveRequest<OmsIdsRequest, OmsIdsResponse>(url, requestPayload);

        return protectSubscription(
            requestObservable,
            this.onDataSuccessfulRetrieval
        );
    };

    private onDataSuccessfulRetrieval = (response: OmsIdsResponse) => {
        const newRecordsMap = response.senRef.reduce<Record<number, string>>((acc, record) => {
            return {
                ...acc,
                [record.senTix]: record.ref
            };
        }, {});

        this.omsIdMap = {
            ...this.omsIdMap,
            ...newRecordsMap
        };

        this.saveMap();
    };
}
